import React, { lazy } from "react";

import { VIEW_ACCOUNTS_PERMISSION } from "constants/permissions";

const AccountsPage = lazy(() => import("./AccountsPage"));

const accountsRoute = {
  path: "accounts",
  element: <AccountsPage />,
  root: true,
  permission: VIEW_ACCOUNTS_PERMISSION,
};

export default accountsRoute;
